
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"34","height":"34","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.9 12.5l-1.4-1.4-4.5 4.5-4.5-4.5-1.4 1.4 4.5 4.5-4.5 4.5 1.4 1.4 4.5-4.5 4.5 4.5 1.4-1.4-4.5-4.5 4.5-4.5z","fill":"#F9A91E"}}),_c('path',{attrs:{"d":"M21.5 31H4c-.6 0-1-.4-1-1V4c0-.6.4-1 1-1h26c.6 0 1 .4 1 1v17.5c0 .6-.4 1-1 1s-1-.4-1-1V5H5v24h16.5c.6 0 1 .4 1 1s-.5 1-1 1z","fill":"#47AEA6"}})])
          )
        }
      }
    